<template>
  <section>
    <v-dialog
      v-model="dialog"
      width="500px">
      <div class="dialog-container">
        <h2>Change Claim Status</h2>
        <div class="abs-top-right">
          <v-button @click="dialog = false">Cancel</v-button>
          <v-button
            type="primary"
            @click="handlerSubmit">Submit</v-button>
        </div>
        <div class="status-container">
          <v-button
            type="warning"
            :icon="status === 0? 'check': ''"
            @click="changeStatus(0)">Recieved</v-button>
          <div class="line"></div>
          <v-button
            type="primary"
            :icon="status === 1? 'check': ''"
            @click="changeStatus(1)">Processing</v-button>
          <div class="line"></div>
          <div class="furcation"></div>
          <div class="group">
            <v-button
              type="primary"
              plain
              :icon="status === 2? 'check': ''"
              @click="changeStatus(2)">Settled</v-button>
            <v-button
              type="success"
              plain
              :icon="status === 3? 'check': ''"
              @click="changeStatus(3)">Settled with Cheque</v-button>
          </div>
        </div>
      </div>
    </v-dialog>

    <send-email-sms
      ref="send-email-sms"
      :is-edit="true"
      updateContent
      :form="detailData"
      :initContent="initContent"
      :init-refer-content="initContent"
      :emailListTitle="emailListTitle"
      :is-fina="isFina"
      :is-only-referrer="isFina&&status==3"
      :emailTitle="emailTitle"
      @skip="handlerSkip"
      @send="handlerSend" />
  </section>
</template>
<script>
import {setClaimStatus} from '@/api/claim'
import SendEmailSms from '@/views/components/dialogs/send-email-sms'

export default {
  name: 'ChangeClaimStatus',
  components:{
    SendEmailSms
  },
  props: {
    claimId: [String, Number],
    claimStatus: {
      type: Number,
      default: 0
    },
    renewOrderSn:{
      type: String,
      default: ''
    },
    detailData:{
      type: Object,
      default: () => {}
    },
    relation:{
      type: Object,
      default: () => {}
    },
    customers:{
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialog: false,
      status: 0, // 0:received,1:processing,2:setted
      is_send: 0,
      content: ''
    }
  },
  computed:{
    isFina(){
      let {merchant_platform} = this.detailData||{}
      return merchant_platform == 2
    },
    initContent(){
      let content = ''
      let {claim_processing_url_data,claim_no_cheque_url_data,claim_success_url_data} = this.relation||{}
      if(this.status == 1){
        content = claim_processing_url_data
      }else if(this.status == 2){
        content =claim_no_cheque_url_data
      }else if(this.status == 3){
        content = claim_success_url_data
      }
      return content
    },
    emailTitle(){
      let title = ''
      let {claim_processing_title,claim_no_cheque_title,claim_success_title} = this.relation||{}
      if(this.status == 1){
        title = claim_processing_title
      }else if(this.status == 2){
        title =claim_no_cheque_title
      }else if(this.status == 3){
        title =claim_success_title
      }
      return title
    },
    emailListTitle(){
      let {claim_list_title} = this.relation||{}
      return claim_list_title
    },
    customerData(){
      return this.customers
    },
  },
  watch: {
    claimStatus: {
      immediate: true,
      handler(val) {
        this.status = val
      }
    }
  },
  methods: {
    changeDialog() {
      this.dialog = !this.dialog
    },
    changeStatus(status) {
      this.status = status
    },
    handlerSubmit() {
      // this.handleUpdate()
      if(this.renewOrderSn){
        this.$emit('nextStep', 5)
      }else{
        if(this.isFina&&this.status!=3)
          this.network().setClaimStatus()
        else
          this.$refs['send-email-sms'].changeDialog()
      }
    },
    handleUpdate(){
      this.$emit('update')
    },
    handlerSkip(){
      this.is_send = 0
      this.network().setClaimStatus()
    },
    handlerSend(content,type,data){
      let {referrer_content} = data
      this.is_send = 1
      this.content = this.isFina?referrer_content:content
      this.network().setClaimStatus()
    },
    network() {
      return {
        setClaimStatus: async () => {
          const { data } = await setClaimStatus({
            claim_id: this.claimId,
            status: this.status,
            is_send: this.is_send,
            content: this.content
          })
          this.$message({
            type: 'success',
            message: data.message_language
          })
          // this.$refs['send-email-sms'].changeDialog()
          this.dialog = false
          this.$emit('success', this.status)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
  position: relative;
  padding: 15px;
   .abs-top-right {
      padding: 20px 15px;
  }
  .status-container {
    //   position: relative;
    //   display: flex;
    //   justify-content: space-between;
    //   margin-top: 20px;
    //   margin-bottom: 20px;
    //   z-index: 1;
    //   .el-button {
    //       z-index: 2;
    //     //   min-width: 120px;
    //   }
    // &::before {
    //     content: '';
    //     position: absolute;
    //     top: 50%;
    //     left: 0;
    //     right: 0;
    //     height: 2px;
    //     transform: translateY(-50%);
    //     background: #dddfe7;
    //     z-index: 0;
    // }
    display: flex;
    align-items: center;
    .line{
      background: #dddfe7;
      height: 2px;
      width: 50px;
    }
    .furcation{
      border: 2px solid #dddfe7;
      border-right: none;
      height: 100px;
      width: 70px;
    }
    .group{
      height: 128px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .el-button+.el-button{
        margin: 0;
      }
    }
  }
}
</style>
